import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { JobDto } from '../../job/dto/job.dto';
import { JobPhaseWorkApprovalBatchErrorInterface } from '../interfaces/job-phase-work-approval-batch-error.interface';

@Exclude()
export class JobPhaseWorkApprovalBatchErrorDto
  implements JobPhaseWorkApprovalBatchErrorInterface
{
  @ApiProperty({
    title: 'Job',
    description: 'Job',
  })
  @Expose()
  job!: JobDto;

  @ApiProperty({
    title: 'Error Message',
    description: 'Error Message',
  })
  @Expose()
  errorMessage!: string;
}
